import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogCreatePage } from '@/features/data/catalog/catalog-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/catalog/$layer/new')({ component: NewDatabaseRoute });

function NewDatabaseRoute() {
  const { tenant, layer } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[
        { label: t('nav.items.catalog') },
        { label: layer, mono: true },
        { label: t('data.catalog.new.database') },
      ]}
    >
      <CatalogCreatePage tenantId={tenant} parent={{ level: 'layer', layer }} />
    </ConsoleShell>
  );
}
